export const GENERATE_IMAGE_REQUEST = 'GENERATE_IMAGE_REQUEST';
export const GENERATE_IMAGE_SUCCESS = 'GENERATE_IMAGE_SUCCESS';
export const GENERATE_IMAGE_FAILURE = 'GENERATE_IMAGE_FAILURE';